import { render } from "./WhitelabelMore.vue?vue&type=template&id=6a34d5aa&scoped=true&ts=true"
import script from "./WhitelabelMore.vue?vue&type=script&lang=ts"
export * from "./WhitelabelMore.vue?vue&type=script&lang=ts"

import "./WhitelabelMore.vue?vue&type=style&index=0&id=6a34d5aa&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a34d5aa"]])

export default __exports__